import { render, staticRenderFns } from "./ProfitCenterPage.vue?vue&type=template&id=97afd9d0&scoped=true&lang=pug&"
import script from "./ProfitCenterPage.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97afd9d0",
  null
  
)

export default component.exports